<template>
    <div class="card">
      <div class="ad-new-simulation">
        <h4>Modo Relatório</h4>
        <a class="btn btn-success btn-fill btn-squared pull-right" @click="$emit('downloadReport')">Visualizar</a>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-md-12">
          <iframe v-if="urlPdf" v-on:load="escondeDiv" :src="urlPdf" height="500" type="application/pdf" ></iframe>
        </div>
      </div>
      <div class="baixa-pdf">
        <div class="card-content">
          <p>Caso você não consiga vizualizar este relatorio, clique no botão acima para visualizar.</p>
          <!-- <a class="btn btn-success btn-fill btn-squared pull-right btn-mobile" @click="$emit('downloadReport')">Baixar</a> -->

        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: ['urlPdf'],
  created () {
    let vm = this
    setTimeout(() => {
      vm.mostraDiv = true
    }, 2000);
  },
  methods:{
    escondeDiv () {
      this.mostraDiv = false
    }
  },
  data () {
    return {
      mostraDiv: false
    }
  }
}
</script>

<style scoped lang="scss">
  iframe {
    height: 95vh;
    width: 97.6%;
    z-index: 99999999999;
    border-width: 0px;
  }

  .baixa-pdf{
    display: none;
  }

  .btn{
    &-desk{
      display: block
    }
    &-mobile{
      display: none
    }
  }
  @media only screen and (max-width:800px) {
    iframe {
      height: 95vh;
      display: none;
    }
    .btn{
      &-desk{
        display: none
      }
      &-mobile{
        display: block
        }
    }
    .baixa-pdf{
      width: 100%;
      display: block;
      margin-top: 2rem;
      background-color: #fff;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Simulacoes/Relatorios/modoRelatorio/modoRelatorio.vue